import type { StyleRule } from '@archipro-design/aria';
import { gridClassName } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import { labelClassName } from '@fluentui/react-northstar';

interface LocationListItemProps {
    isClicked?: boolean;
    isHovered?: boolean;
}

export const LocationListItem: StyleRule<LocationListItemProps> = ({
    theme,
    isClicked,
    isHovered,
}) => {
    const HOVERED_BG_COLOR = '#E8E9EB'; // can't find this color in theme
    const CLICKED_BG_COLOR = '#DBDBDB'; // can't find this color in theme

    return {
        padding: pxArrayToRem([6, 15, 6, 0]),
        cursor: 'pointer',
        gridGap: pxToRem(21),

        backgroundColor: isClicked
            ? CLICKED_BG_COLOR
            : isHovered
            ? HOVERED_BG_COLOR
            : 'transparent',

        '&:hover': {
            backgroundColor: HOVERED_BG_COLOR,
        },
        '&:active': {
            backgroundColor: CLICKED_BG_COLOR,
        },

        [`& .${labelClassName}`]: {
            fontSize: theme.siteVariables.fontSizes['label03-alt'],
        },

        [`& .${gridClassName}`]:{
            alignItems: 'center',
            gridGap: pxToRem(4),
        },
    };
};

export const LocationActions: StyleRule<LocationListItemProps> = {
    [`& > div:last-child`]: {
        marginLeft: pxToRem(45),
    },
};
